import { styled } from 'styled-components';

export enum LinkType {
    NORMAL,
    SMALL,
}

export const Root = styled.a<{ $inline: boolean; $isAction: boolean; $linkType: LinkType }>`
    background: none;
    color: ${(props) =>
        props.$isAction ? props.theme.actionLinkTextColor : props.theme.linkTextColor};
    border: none;
    font-family: ${(props) => props.theme.fontBase};
    font-weight: 400;
    font-size: ${({ $inline, $linkType, theme }) =>
        $inline
            ? 'inherit'
            : $linkType === LinkType.NORMAL
              ? theme.spacing(3.5)
              : theme.spacing(3)};
    line-height: ${(props) => props.theme.spacing(4.5)};
    cursor: pointer;
    text-decoration: underline;
    letter-spacing: 0.01em;
`;
